var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * A class that represents the configuration of options related to timescale on scheduler.
 */
export class TimeScale extends ChildProperty {
}
__decorate([
    Property(true)
], TimeScale.prototype, "enable", void 0);
__decorate([
    Property(60)
], TimeScale.prototype, "interval", void 0);
__decorate([
    Property(2)
], TimeScale.prototype, "slotCount", void 0);
__decorate([
    Property()
], TimeScale.prototype, "minorSlotTemplate", void 0);
__decorate([
    Property()
], TimeScale.prototype, "majorSlotTemplate", void 0);
